/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  getWhatsappProfile(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_profile`);
  }

  getWhatsappInsights(
    inboxId,
    { startDate, endDate, country },
    { signal } = {}
  ) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_insights`, {
      params: { start_date: startDate, end_date: endDate, country },
      signal,
    });
  }

  updateWhatsappProfile(inboxId, { websites, picture, ...fields }) {
    const formData = new FormData();
    Object.entries(fields).forEach(([key, value]) =>
      formData.append(key, value ?? '')
    );
    // An empty entry still sends the key, so clearing every website clears them on WhatsApp too
    (websites.length ? websites : ['']).forEach(url =>
      formData.append('websites[]', url)
    );
    if (picture) formData.append('picture', picture);
    return axios.patch(`${this.url}/${inboxId}/whatsapp_profile`, formData);
  }
}

export default new InboxHealthAPI();
